import { useState } from 'react'

function PricingGrid({ 
  pricing, 
  selectedDuration, 
  onDurationChange, 
  imageCount = null,
  type = 'article' // 'article', 'video', 'banner'
}) {
  const durations = [
    { days: 1, label: '1 jour', icon: '⚡' },
    { days: 3, label: '3 jours', icon: '📅', badge: 'Populaire' },
    { days: 7, label: '7 jours', icon: '🔥', badge: 'Recommandé' },
    { days: 30, label: '30 jours', icon: '👑', badge: 'Meilleur prix' }
  ]

  const getTypeLabel = () => {
    if (type === 'article' && imageCount) {
      return `${imageCount} image${imageCount > 1 ? 's' : ''}`
    }
    return type === 'video' ? 'Vidéo' : type === 'banner' ? 'Bannière' : 'Article'
  }

  return (
    <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl p-6 border-2 border-blue-100">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-[#001F3F] flex items-center gap-2">
          <svg className="w-6 h-6 text-[#D4AF37]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Choisissez votre durée
        </h3>
        {imageCount && (
          <span className="px-3 py-1 bg-[#D4AF37] text-white text-xs font-bold rounded-full">
            {getTypeLabel()}
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {durations.map((duration) => {
          const price = pricing[duration.days] || 0
          const isSelected = selectedDuration === duration.days
          
          return (
            <button
              key={duration.days}
              type="button"
              onClick={() => onDurationChange(duration.days)}
              className={`relative p-5 rounded-xl border-2 transition-all duration-300 transform hover:scale-105 ${
                isSelected
                  ? 'border-[#D4AF37] bg-gradient-to-br from-[#D4AF37] to-[#C49B2E] text-white shadow-lg shadow-[#D4AF37]/30'
                  : 'border-gray-200 bg-white hover:border-[#D4AF37] hover:shadow-md'
              }`}
            >
              {duration.badge && (
                <div className={`absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap ${
                  isSelected 
                    ? 'bg-white text-[#D4AF37]' 
                    : 'bg-gradient-to-r from-blue-500 to-purple-500 text-white'
                }`}>
                  {duration.badge}
                </div>
              )}
              
              <div className="text-center">
                <div className="text-3xl mb-2">{duration.icon}</div>
                <div className={`text-sm font-semibold mb-3 ${isSelected ? 'text-white' : 'text-gray-600'}`}>
                  {duration.label}
                </div>
                <div className={`text-2xl font-bold ${isSelected ? 'text-white' : 'text-[#001F3F]'}`}>
                  {price.toLocaleString('fr-FR')}
                  <span className="text-sm font-normal ml-1">FCFA</span>
                </div>
                {duration.days === 30 && (
                  <div className={`text-xs mt-2 ${isSelected ? 'text-white/90' : 'text-gray-500'}`}>
                    ~{Math.round(price / 30)} FCFA/jour
                  </div>
                )}
              </div>

              {isSelected && (
                <div className="absolute top-2 right-2">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </button>
          )
        })}
      </div>

      <div className="mt-6 p-4 bg-white rounded-xl border border-blue-200">
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <p className="text-sm font-semibold text-gray-700 mb-1">
              {type === 'article' ? '💡 Conseil : Plus de durée = Plus de visibilité' : 
               type === 'video' ? '💡 Les vidéos restent actives pendant toute la durée sélectionnée' :
               '💡 Votre bannière sera affichée en haut de page'}
            </p>
            <p className="text-xs text-gray-500">
              {type === 'article' ? 'Les annonces de longue durée apparaissent plus souvent dans les résultats' :
               type === 'video' ? 'Maximisez votre portée avec une durée de 30 jours' :
               'Position premium garantie pendant toute la durée'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingGrid
